import React from "react";
import { FormattedMessage } from "react-intl";
import { Space } from "@masterteam/mt-design-react";

import useIsAr from "../../../Hooks/useIsAr";
import { formatDate } from "../../../helpers";

import { ReactComponent as UpdateIcon } from "../../../assets/images/update-group.svg";
import { ReactComponent as DangerIcon } from "../../../assets/images/Danger.svg";

import "./style.scss";

function UpdateStatus({ data, onShowPopup, oldestDueDate }) {
  const [isAr] = useIsAr();

  const requireUpdate = data[0].KPIs;
  const updatedKPIs = data[1].KPIs;

  const requireUpdatePercent = data[0].Percentage;
  const updatePercent = data[1].Percentage;

  const UpdateWidth = updatePercent / 2 > 50 ? 50 : updatePercent / 2;
  const requiredWidth =
    requireUpdatePercent / 2 > 50 ? 50 : requireUpdatePercent / 2;
  const calcAfterStartPoint = 50 + 2;
  const calcBeforeStartPoint = 50 + 2;

  return (
    <div className="update-status-container">
      <div className="update-status-container__header">
        <Space
          align="center"
          className={`cursor update ${isAr ? "update-ar" : ""}`}
          onClick={() => onShowPopup(updatedKPIs)}
        >
          <span>
            {data[1].KPICount} <FormattedMessage id="common.kpis" />
          </span>
          <b>{updatePercent}%</b>
        </Space>
        <Space
          align="center"
          className={`cursor required ${isAr ? "required-ar" : ""}`}
          onClick={() => onShowPopup(requireUpdate)}
        >
          <b>{requireUpdatePercent}%</b>
          <span>
            {data[0].KPICount} <FormattedMessage id="common.kpis" />{" "}
          </span>
        </Space>
      </div>
      <div
        style={{
          "--after-width": `${UpdateWidth}%`,
          "--after-right": `${!isAr && calcAfterStartPoint}%`,
          "--after-left": `${isAr && calcAfterStartPoint}%`,
          "--before-width": `${requiredWidth}%`,
          "--before-right": `${isAr && calcBeforeStartPoint}%`,
          "--before-left": `${!isAr && calcBeforeStartPoint}%`,
        }}
        className="update-status-container__horizontal-bar"
      >
        <UpdateIcon />
      </div>
      <div className="update-status-container__labels">
        <div className="cursor" onClick={() => onShowPopup(updatedKPIs)}>
          <FormattedMessage id="common.up-tp-date" />
        </div>
        <div className="cursor" onClick={() => onShowPopup(requireUpdate)}>
          <FormattedMessage id="status.not-updated" />
        </div>
      </div>
      {Boolean(data[0]?.KPICount && oldestDueDate) && (
        <div className="update-status-container__warning">
          <DangerIcon /> <FormattedMessage id="kpis-update-status-warning" />
          &nbsp;
          <span>{formatDate(oldestDueDate)}</span>
        </div>
      )}
    </div>
  );
}

export default UpdateStatus;
